import { LoanRequest_ApplicantNoteAdded } from 'cpool-events';
import { schemaId } from 'cpool-schemas';
import { z } from 'zod';

// export type ApplicantNotesTableSchema = {
//     id: string;
//     applicantHash: string;
//     applicantId: string;
//     notes: Array<Omit<EventSchema<LoanRequest_ApplicantNoteAdded>, 'applicantId'> & { createdAt: Date }>;
// };

export const ApplicantNotesTableDefinitionZod = z.object({
    applicantHash: z.string().nullable(), // this is nullable until the applicant is indexed
    applicantId: schemaId,
    id: schemaId,
    notes: z.array(
        LoanRequest_ApplicantNoteAdded.prototype
            .getSchema()
            .omit({ applicantId: true })
            .merge(z.object({ createdAt: z.coerce.date() })),
    ),
});

export type ApplicantNotesTableSchema = z.infer<typeof ApplicantNotesTableDefinitionZod>;
